var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelBlog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 56v-4h60v4zm0-8v-4h60v4zm0-8v-4h60v4zm60 16.019A4.31 4.31 0 0 1 55.685 60H4.315C2.032 60 .168 58.244.011 56.019L0 53.876V17.143h60v38.876m0-38.876V4.285C60 1.918 58.072 0 55.685 0H4.315C1.932 0 0 1.902 0 4.285v12.858z"
})));
export default SvgChannelBlog;